import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const PasswordInputComponent = ({ passwordInput = {} }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);

  const isHovered = passwordInput.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = passwordInput;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = passwordInput;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = passwordInput;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = passwordInput;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = passwordInput;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        passwordInput.backgroundImage &&
        passwordInput.backgroundImage.startsWith("./")
      ) {
        const imageName = passwordInput.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(passwordInput.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [passwordInput.backgroundImage, files]);

  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        passwordInput.labelbackgroundImagelabel &&
        passwordInput.labelbackgroundImagelabel.startsWith("./")
      ) {
        const imageName = passwordInput.labelbackgroundImagelabel.replace(
          "./",
          ""
        );
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(
          passwordInput.labelbackgroundImagelabel
        );
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [passwordInput.labelbackgroundImagelabel, files]);

  const focusedStyles =
  isDivFocused && passwordInput.pseudoClass === "focus"
    ? {
        width: passwordInput.focusedwidth || passwordInput.width || "200px",
        height: passwordInput.focusedheight || passwordInput.height || "auto",

        padding: passwordInput.focusedpadding || passwordInput.padding || "0",
        paddingTop:
          passwordInput.focusedpaddingTop || passwordInput.focusedpadding || "0",
        paddingRight:
          passwordInput.focusedpaddingRight || passwordInput.focusedpadding || "0",
        paddingBottom:
          passwordInput.focusedpaddingBottom || passwordInput.focusedpadding || "0",
        paddingLeft:
          passwordInput.focusedpaddingLeft || passwordInput.focusedpadding || "0",
        margin: passwordInput.focusedmargin || passwordInput.margin || "0px",
        marginTop:
          passwordInput.focusedmarginTop || passwordInput.focusedmargin || "0px",
        marginRight:
          passwordInput.focusedmarginRight || passwordInput.focusedmargin || "0px",
        marginBottom:
          passwordInput.focusedmarginBottom || passwordInput.focusedmargin || "0px",
        marginLeft:
          passwordInput.focusedmarginLeft || passwordInput.focusedmargin || "10px",

        borderTop:
          passwordInput.focusedborderTop ||
          passwordInput.focusedborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderRight:
          passwordInput.focusedborderRight ||
          passwordInput.focusedborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderBottom:
          passwordInput.focusedborderBottom ||
          passwordInput.focusedborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderLeft:
          passwordInput.focusedborderLeft ||
          passwordInput.focusedborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderSapcing:
          passwordInput.focusedborderSpacing || passwordInput.borderSpacing || "0px",
        borderCollapse:
          passwordInput.focusedborderCollapse ||
          passwordInput.borderCollapse ||
          "0px",
        borderRadius:
          passwordInput.focusedborderRadius || passwordInput.borderRadius || "0",
        outline: passwordInput.focusedoutline || passwordInput.outline || "none",

        position:
          passwordInput.focusedposition || passwordInput.position || "relative",
        top: passwordInput.focusedtop || passwordInput.top || "auto",
        right: passwordInput.focusedright || passwordInput.right || "auto",
        bottom: passwordInput.focusedbottom || passwordInput.bottom || "auto",
        left: passwordInput.focusedleft || passwordInput.left || "auto",
        zIndex: passwordInput.focusedzIndex || passwordInput.zIndex || "auto",

        color: passwordInput.focusedcolor || passwordInput.color || "#000000",
        backgroundColor:
          passwordInput.focusedbackgroundColor ||
          passwordInput.backgroundColor ||
          "#ffffff",
        backgroundImage: (() => {
          if (passwordInput.focusedbackgroundImage) {
            if (passwordInput.focusedbackgroundImage.startsWith("./")) {
              const imageName = passwordInput.focusedbackgroundImage.replace(
                "./",
                ""
              );
              const file = files.find((f) => f.name === imageName);
              return file && file.data ? `url(${file.data})` : "none";
            }
            return `url(${passwordInput.focusedbackgroundImage})`;
          }
          if (passwordInput.backgroundImage) {
            if (passwordInput.backgroundImage.startsWith("./")) {
              const imageName = passwordInput.backgroundImage.replace("./", "");
              const file = files.find((f) => f.name === imageName);
              return file && file.data ? `url(${file.data})` : "none";
            }
            return `url(${passwordInput.backgroundImage})`;
          }
          return (
            constructFocusedGradientString() ||
            constructGradientString() ||
            "none"
          );
        })(),
        backgroundPosition:
          passwordInput.focusedbackgroundPosition ||
          passwordInput.backgroundPosition ||
          "0% 0%",
        backgroundSize:
          passwordInput.focusedbackgroundSize ||
          passwordInput.backgroundSize ||
          "auto",
        backgroundRepeat:
          passwordInput.focusedbackgroundRepeat ||
          passwordInput.backgroundRepeat ||
          "repeat",
        backgroundAttachment:
          passwordInput.focusedbackgroundAttachment ||
          passwordInput.backgroundAttachment ||
          "scroll",

        boxShadow:
          passwordInput.focusedboxShadow || passwordInput.boxShadow || "none",
        opacity: passwordInput.focusedOpacity || passwordInput.opacity || 1,
        display: passwordInput.focuseddisplay || passwordInput.display || "inline",

        fontFamily:
          passwordInput.focusedfontFamily || passwordInput.fontFamily || "inherit",
        fontSize:
          passwordInput.focusedfontSize || passwordInput.fontSize || "inherit",
        fontWeight:
          passwordInput.focusedfontWeight || passwordInput.fontWeight || "normal",
        fontStyle:
          passwordInput.focusedfontStyle || passwordInput.fontStyle || "normal",
        fontVariant:
          passwordInput.focusedfontVariant || passwordInput.fontVariant || "normal",
        lineHeight:
          passwordInput.focusedlineHeight || passwordInput.lineHeight || "normal",
        textShadow:
          passwordInput.focusedtextShadow || passwordInput.textShadow || "none",
        textAlign:
          passwordInput.focusedtextAlign || passwordInput.textAlign || "left",
        verticalAlign:
          passwordInput.focusedverticalAlign ||
          passwordInput.verticalAlign ||
          "baseline",
        textDecoration:
          passwordInput.focusedtextDecoration ||
          passwordInput.textDecoration ||
          "none",
        textTransform:
          passwordInput.focusedtextTransform || passwordInput.textTransform || "none",
        letterSpacing:
          passwordInput.focusedletterSpacing ||
          passwordInput.letterSpacing ||
          "normal",
        wordSpacing:
          passwordInput.focusedwordSpacing || passwordInput.wordSpacing || "normal",
        textIndent:
          passwordInput.focusedtextIndent || passwordInput.textIndent || "0",
        whiteSpace:
          passwordInput.focusedwhiteSpace || passwordInput.whiteSpace || "normal",
        textOverflow:
          passwordInput.focusedtextOverflow || passwordInput.textOverflow || "clip",
        direction: passwordInput.focuseddirection || passwordInput.direction || "ltr",
        unicodeBidi:
          passwordInput.focusedunicodeBidi || passwordInput.unicodeBidi || "normal",
        writingMode:
          passwordInput.focusedwritingMode ||
          passwordInput.writingMode ||
          "horizontal-tb",

        cursor: passwordInput.focusedcursor || passwordInput.cursor || "default",
        transform:
          passwordInput.focusedtransform || passwordInput.transform || "none",
        transition:
          passwordInput.focusedtransition || passwordInput.transition || "none",
      }
    : {};
const hoverStyles =
  isDivHovered && passwordInput.pseudoClass === "hover"
    ? {
        width: passwordInput.hoveredwidth || passwordInput.width || "200px",
        height: passwordInput.hoveredheight || passwordInput.height || "auto",

        padding: passwordInput.hoveredpadding || passwordInput.padding || "0",
        paddingTop:
          passwordInput.hoveredpaddingTop || passwordInput.hoveredpadding || "0",
        paddingRight:
          passwordInput.hoveredpaddingRight || passwordInput.hoveredpadding || "0",
        paddingBottom:
          passwordInput.hoveredpaddingBottom || passwordInput.hoveredpadding || "0",
        paddingLeft:
          passwordInput.hoveredpaddingLeft || passwordInput.hoveredpadding || "0",
        margin: passwordInput.hoveredmargin || passwordInput.margin || "0px",
        marginTop:
          passwordInput.hoveredmarginTop || passwordInput.hoveredmargin || "0px",
        marginRight:
          passwordInput.hoveredmarginRight || passwordInput.hoveredmargin || "0px",
        marginBottom:
          passwordInput.hoveredmarginBottom || passwordInput.hoveredmargin || "0px",
        marginLeft:
          passwordInput.hoveredmarginLeft || passwordInput.hoveredmargin || "10px",

        borderTop:
          passwordInput.hoveredborderTop ||
          passwordInput.hoveredborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderRight:
          passwordInput.hoveredborderRight ||
          passwordInput.hoveredborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderBottom:
          passwordInput.hoveredborderBottom ||
          passwordInput.hoveredborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderLeft:
          passwordInput.hoveredborderLeft ||
          passwordInput.hoveredborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderSapcing:
          passwordInput.hoveredborderSpacing || passwordInput.borderSpacing || "0px",
        borderCollapse:
          passwordInput.hoveredborderCollapse ||
          passwordInput.borderCollapse ||
          "0px",
        borderRadius:
          passwordInput.hoveredborderRadius || passwordInput.borderRadius || "0",
        outline: passwordInput.hoveredoutline || passwordInput.outline || "none",

        position:
          passwordInput.hoveredposition || passwordInput.position || "relative",
        top: passwordInput.hoveredtop || passwordInput.top || "auto",
        right: passwordInput.hoveredright || passwordInput.right || "auto",
        bottom: passwordInput.hoveredbottom || passwordInput.bottom || "auto",
        left: passwordInput.hoveredleft || passwordInput.left || "auto",
        zIndex: passwordInput.hoveredzIndex || passwordInput.zIndex || "auto",

        color: passwordInput.hoveredcolor || passwordInput.color || "#000000",
        backgroundColor:
          passwordInput.hoveredbackgroundColor ||
          passwordInput.backgroundColor ||
          "#ffffff",
        backgroundImage: (() => {
          if (passwordInput.hoveredbackgroundImage) {
            if (passwordInput.hoveredbackgroundImage.startsWith("./")) {
              const imageName = passwordInput.hoveredbackgroundImage.replace(
                "./",
                ""
              );
              const file = files.find((f) => f.name === imageName);
              return file && file.data ? `url(${file.data})` : "none";
            }
            return `url(${passwordInput.hoveredbackgroundImage})`;
          }
          if (passwordInput.backgroundImage) {
            if (passwordInput.backgroundImage.startsWith("./")) {
              const imageName = passwordInput.backgroundImage.replace("./", "");
              const file = files.find((f) => f.name === imageName);
              return file && file.data ? `url(${file.data})` : "none";
            }
            return `url(${passwordInput.backgroundImage})`;
          }
          return (
            constructHoverGradientString() ||
            constructGradientString() ||
            "none"
          );
        })(),
        backgroundPosition:
          passwordInput.hoveredbackgroundPosition ||
          passwordInput.backgroundPosition ||
          "0% 0%",
        backgroundSize:
          passwordInput.hoveredbackgroundSize ||
          passwordInput.backgroundSize ||
          "auto",
        backgroundRepeat:
          passwordInput.hoveredbackgroundRepeat ||
          passwordInput.backgroundRepeat ||
          "repeat",
        backgroundAttachment:
          passwordInput.hoveredbackgroundAttachment ||
          passwordInput.backgroundAttachment ||
          "scroll",

        boxShadow:
          passwordInput.hoveredboxShadow || passwordInput.boxShadow || "none",
        opacity: passwordInput.hoveredOpacity || passwordInput.opacity || 1,
        display: passwordInput.hovereddisplay || passwordInput.display || "inline",

        fontFamily:
          passwordInput.hoveredfontFamily || passwordInput.fontFamily || "inherit",
        fontSize:
          passwordInput.hoveredfontSize || passwordInput.fontSize || "inherit",
        fontWeight:
          passwordInput.hoveredfontWeight || passwordInput.fontWeight || "normal",
        fontStyle:
          passwordInput.hoveredfontStyle || passwordInput.fontStyle || "normal",
        fontVariant:
          passwordInput.hoveredfontVariant || passwordInput.fontVariant || "normal",
        lineHeight:
          passwordInput.hoveredlineHeight || passwordInput.lineHeight || "normal",
        textShadow:
          passwordInput.hoveredtextShadow || passwordInput.textShadow || "none",
        textAlign:
          passwordInput.hoveredtextAlign || passwordInput.textAlign || "left",
        verticalAlign:
          passwordInput.hoveredverticalAlign ||
          passwordInput.verticalAlign ||
          "baseline",
        textDecoration:
          passwordInput.hoveredtextDecoration ||
          passwordInput.textDecoration ||
          "none",
        textTransform:
          passwordInput.hoveredtextTransform || passwordInput.textTransform || "none",
        letterSpacing:
          passwordInput.hoveredletterSpacing ||
          passwordInput.letterSpacing ||
          "normal",
        wordSpacing:
          passwordInput.hoveredwordSpacing || passwordInput.wordSpacing || "normal",
        textIndent:
          passwordInput.hoveredtextIndent || passwordInput.textIndent || "0",
        whiteSpace:
          passwordInput.hoveredwhiteSpace || passwordInput.whiteSpace || "normal",
        textOverflow:
          passwordInput.hoveredtextOverflow || passwordInput.textOverflow || "clip",
        direction: passwordInput.hovereddirection || passwordInput.direction || "ltr",
        unicodeBidi:
          passwordInput.hoveredunicodeBidi || passwordInput.unicodeBidi || "normal",
        writingMode:
          passwordInput.hoveredwritingMode ||
          passwordInput.writingMode ||
          "horizontal-tb",

        cursor: passwordInput.hoveredcursor || passwordInput.cursor || "default",
        transform:
          passwordInput.hoveredtransform || passwordInput.transform || "none",
        transition:
          passwordInput.hoveredtransition || passwordInput.transition || "none",
      }
    : {};
const activeStyles =
  isDivActive && passwordInput.pseudoClass === "active"
    ? {
        width: passwordInput.activatedwidth || passwordInput.width || "200px",
        height: passwordInput.activatedheight || passwordInput.height || "auto",

        padding: passwordInput.activatedpadding || passwordInput.padding || "0",
        paddingTop:
          passwordInput.activatedpaddingTop || passwordInput.activatedpadding || "0",
        paddingRight:
          passwordInput.activatedpaddingRight ||
          passwordInput.activatedpadding ||
          "0",
        paddingBottom:
          passwordInput.activatedpaddingBottom ||
          passwordInput.activatedpadding ||
          "0",
        paddingLeft:
          passwordInput.activatedpaddingLeft || passwordInput.activatedpadding || "0",
        margin: passwordInput.activatedmargin || passwordInput.margin || "0px",
        marginTop:
          passwordInput.activatedmarginTop || passwordInput.activatedmargin || "0px",
        marginRight:
          passwordInput.activatedmarginRight ||
          passwordInput.activatedmargin ||
          "0px",
        marginBottom:
          passwordInput.activatedmarginBottom ||
          passwordInput.activatedmargin ||
          "0px",
        marginLeft:
          passwordInput.activatedmarginLeft || passwordInput.activatedmargin || "10px",

        borderTop:
          passwordInput.activatedborderTop ||
          passwordInput.activatedborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderRight:
          passwordInput.activatedborderRight ||
          passwordInput.activatedborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderBottom:
          passwordInput.activatedborderBottom ||
          passwordInput.activatedborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderLeft:
          passwordInput.activatedborderLeft ||
          passwordInput.activatedborder ||
          passwordInput.border ||
          "1px solid #000000",
        borderSapcing:
          passwordInput.activatedborderSpacing ||
          passwordInput.borderSpacing ||
          "0px",
        borderCollapse:
          passwordInput.activatedborderCollapse ||
          passwordInput.borderCollapse ||
          "0px",
        borderRadius:
          passwordInput.activatedborderRadius || passwordInput.borderRadius || "0",
        outline: passwordInput.activatedoutline || passwordInput.outline || "none",

        position:
          passwordInput.activatedposition || passwordInput.position || "relative",
        top: passwordInput.activatedtop || passwordInput.top || "auto",
        right: passwordInput.activatedright || passwordInput.right || "auto",
        bottom: passwordInput.activatedbottom || passwordInput.bottom || "auto",
        left: passwordInput.activatedleft || passwordInput.left || "auto",
        zIndex: passwordInput.activatedzIndex || passwordInput.zIndex || "auto",

        color: passwordInput.activatedcolor || passwordInput.color || "#000000",
        backgroundColor:
          passwordInput.activatedbackgroundColor ||
          passwordInput.backgroundColor ||
          "#ffffff",
        backgroundImage: (() => {
          if (passwordInput.activatedbackgroundImage) {
            if (passwordInput.activatedbackgroundImage.startsWith("./")) {
              const imageName = passwordInput.activatedbackgroundImage.replace(
                "./",
                ""
              );
              const file = files.find((f) => f.name === imageName);
              return file && file.data ? `url(${file.data})` : "none";
            }
            return `url(${passwordInput.activatedbackgroundImage})`;
          }
          if (passwordInput.backgroundImage) {
            if (passwordInput.backgroundImage.startsWith("./")) {
              const imageName = passwordInput.backgroundImage.replace("./", "");
              const file = files.find((f) => f.name === imageName);
              return file && file.data ? `url(${file.data})` : "none";
            }
            return `url(${passwordInput.backgroundImage})`;
          }
          return (
            constructActivatedGradientString() ||
            constructGradientString() ||
            "none"
          );
        })(),
        backgroundPosition:
          passwordInput.activatedbackgroundPosition ||
          passwordInput.backgroundPosition ||
          "0% 0%",
        backgroundSize:
          passwordInput.activatedbackgroundSize ||
          passwordInput.backgroundSize ||
          "auto",
        backgroundRepeat:
          passwordInput.activatedbackgroundRepeat ||
          passwordInput.backgroundRepeat ||
          "repeat",
        backgroundAttachment:
          passwordInput.activatedbackgroundAttachment ||
          passwordInput.backgroundAttachment ||
          "scroll",

        boxShadow:
          passwordInput.activatedboxShadow || passwordInput.boxShadow || "none",
        opacity: passwordInput.activatedOpacity || passwordInput.opacity || 1,
        display: passwordInput.activateddisplay || passwordInput.display || "inline",

        fontFamily:
          passwordInput.activatedfontFamily || passwordInput.fontFamily || "inherit",
        fontSize:
          passwordInput.activatedfontSize || passwordInput.fontSize || "inherit",
        fontWeight:
          passwordInput.activatedfontWeight || passwordInput.fontWeight || "normal",
        fontStyle:
          passwordInput.activatedfontStyle || passwordInput.fontStyle || "normal",
        fontVariant:
          passwordInput.activatedfontVariant || passwordInput.fontVariant || "normal",
        lineHeight:
          passwordInput.activatedlineHeight || passwordInput.lineHeight || "normal",
        textShadow:
          passwordInput.activatedtextShadow || passwordInput.textShadow || "none",
        textAlign:
          passwordInput.activatedtextAlign || passwordInput.textAlign || "left",
        verticalAlign:
          passwordInput.activatedverticalAlign ||
          passwordInput.verticalAlign ||
          "baseline",
        textDecoration:
          passwordInput.activatedtextDecoration ||
          passwordInput.textDecoration ||
          "none",
        textTransform:
          passwordInput.activatedtextTransform ||
          passwordInput.textTransform ||
          "none",
        letterSpacing:
          passwordInput.activatedletterSpacing ||
          passwordInput.letterSpacing ||
          "normal",
        wordSpacing:
          passwordInput.activatedwordSpacing || passwordInput.wordSpacing || "normal",
        textIndent:
          passwordInput.activatedtextIndent || passwordInput.textIndent || "0",
        whiteSpace:
          passwordInput.activatedwhiteSpace || passwordInput.whiteSpace || "normal",
        textOverflow:
          passwordInput.activatedtextOverflow || passwordInput.textOverflow || "clip",
        direction:
          passwordInput.activateddirection || passwordInput.direction || "ltr",
        unicodeBidi:
          passwordInput.activatedunicodeBidi || passwordInput.unicodeBidi || "normal",
        writingMode:
          passwordInput.activatedwritingMode ||
          passwordInput.writingMode ||
          "horizontal-tb",

        cursor: passwordInput.activatedcursor || passwordInput.cursor || "default",
        transform:
          passwordInput.activatedtransform || passwordInput.transform || "none",
        transition:
          passwordInput.activatedtransition || passwordInput.transition || "none",
      }
    : {};

const inputStyle = {
  width: passwordInput.width || "200px",
  height: passwordInput.height || "auto",

  margin: passwordInput.margin || "0px",
  marginTop: passwordInput.marginTop || passwordInput.margin || "0",
  marginRight: passwordInput.marginRight || passwordInput.margin || "0px",
  marginBottom: passwordInput.marginBottom || passwordInput.margin || "0",
  marginLeft: passwordInput.marginLeft || passwordInput.margin || "10px",
  padding: passwordInput.padding || "0px",
  paddingTop: passwordInput.paddingTop || passwordInput.padding || "0",
  paddingRight: passwordInput.paddingRight || passwordInput.padding || "0",
  paddingBottom: passwordInput.paddingBottom || passwordInput.padding || "0",
  paddingLeft: passwordInput.paddingLeft || passwordInput.padding || "0",

  borderTop: isHovered
    ? "1px dashed #555"
    : passwordInput.borderTop || passwordInput.border || "1px solid #000000",
  borderRight: isHovered
    ? "1px dashed #555"
    : passwordInput.borderRight || passwordInput.border || "1px solid #000000",
  borderBottom: isHovered
    ? "1px dashed #555"
    : passwordInput.borderBottom || passwordInput.border || "1px solid #000000",
  borderLeft: isHovered
    ? "1px dashed #555"
    : passwordInput.borderLeft || passwordInput.border || "1px solid #000000",

  borderSapcing: passwordInput.borderSpacing || "0px",
  borderCollapse: passwordInput.borderCollapse || "0px",
  borderRadius: passwordInput.borderRadius || "0",
  outline: passwordInput.outline || "none",

  position: passwordInput.position || "static",
  top: passwordInput.top || "auto",
  right: passwordInput.right || "auto",
  bottom: passwordInput.bottom || "auto",
  left: passwordInput.left || "auto",
  zIndex: passwordInput.zIndex || "auto",

  color: passwordInput.color || "#000000",
  backgroundColor: passwordInput.backgroundColor || "#ffffff",
  backgroundImage: backgroundImageUrl
    ? `url(${backgroundImageUrl})`
    : constructGradientString(),
  backgroundPosition:
    passwordInput.focusedbackgroundPosition ||
    passwordInput.backgroundPosition ||
    "0% 0%",
  backgroundSize:
    passwordInput.focusedbackgroundSize || passwordInput.backgroundSize || "auto",
  backgroundRepeat:
    passwordInput.focusedbackgroundRepeat ||
    passwordInput.backgroundRepeat ||
    "repeat",
  backgroundAttachment:
    passwordInput.focusedbackgroundAttachment ||
    passwordInput.backgroundAttachment ||
    "scroll",

  fontSize: passwordInput.fontSize || "inherit",
  fontFamily: passwordInput.fontFamily || "inherit",
  fontWeight: passwordInput.fontWeight || "normal",
  fontStyle: passwordInput.fontStyle || "normal",
  fontVariant: passwordInput.fontVariant || "normal",
  lineHeight: passwordInput.lineHeight || "normal",
  textAlign: passwordInput.textAlign || "left",
  textDecoration: passwordInput.textDecoration || "none",
  textTransform: passwordInput.textTransform || "none",
  textShadow: passwordInput.textShadow || "none",
  verticalAlign: passwordInput.verticalAlign || "baseline",
  letterSpacing: passwordInput.letterSpacing || "normal",
  wordSpacing: passwordInput.wordSpacing || "normal",
  textIndent: passwordInput.textIndent || "0",
  whiteSpace: passwordInput.whiteSpace || "normal",
  textOverflow: passwordInput.textOverflow || "clip",
  direction: passwordInput.direction || "ltr",
  unicodeBidi: passwordInput.unicodeBidi || "normal",
  writingMode: passwordInput.writingMode || "horizontal-tb",

  opacity: passwordInput.opacity || "1",
  display: passwordInput.display || "inline",
  cursor: passwordInput.cursor || "auto",

  transform: passwordInput.transform || "none",
  transition: passwordInput.transition || "none",

  scale: isHovered ? "1.01" : "1",
  ...hoverStyles,
  ...focusedStyles,
  ...activeStyles,
};

const labelStyle = {
  margin: passwordInput.labelmargin || "0px",
  marginTop: passwordInput.labelmarginTop || passwordInput.labelmargin || "0",
  marginRight: passwordInput.labelmarginRight || passwordInput.labelmargin || "0px",
  marginBottom: passwordInput.labelmarginBottom || passwordInput.labelmargin || "0",
  marginLeft: passwordInput.labelmarginLeft || passwordInput.labelmargin || "0",
  padding: passwordInput.labelpadding || "0px",
  paddingTop: passwordInput.labelpaddingTop || passwordInput.labelpadding || "0",
  paddingRight: passwordInput.labelpaddingRight || passwordInput.labelpadding || "0",
  paddingBottom:
    passwordInput.labelpaddingBottom || passwordInput.labelpadding || "0",
  paddingLeft: passwordInput.labelpaddingLeft || passwordInput.labelpadding || "0",

  borderTop: isHovered
    ? "1px dashed #555"
    : passwordInput.labelborderTop || passwordInput.labelborder || "none",
  borderRight: isHovered
    ? "1px dashed #555"
    : passwordInput.labelborderRight || passwordInput.labelborder || "none",
  borderBottom: isHovered
    ? "1px dashed #555"
    : passwordInput.labelborderBottom || passwordInput.labelborder || "none",
  borderLeft: isHovered
    ? "1px dashed #555"
    : passwordInput.labelborderLeft || passwordInput.labelborder || "none",

  borderSapcing: passwordInput.labelborderSpacing || "0px",
  borderCollapse: passwordInput.labelborderCollapse || "0px",
  borderRadius: passwordInput.labelborderRadius || "0",
  outline: passwordInput.labeloutline || "none",

  position: passwordInput.labelposition || "static",
  top: passwordInput.labeltop || "auto",
  right: passwordInput.labelright || "auto",
  bottom: passwordInput.labelbottom || "auto",
  left: passwordInput.labelleft || "auto",
  zIndex: passwordInput.labelzIndex || "auto",

  color: passwordInput.labelcolor || "#000000",
  backgroundColor: passwordInput.labelbackgroundColor || "#ffffff",
  backgroundImage: backgroundImagelabelUrl
    ? `url(${backgroundImagelabelUrl})`
    : labelconstructGradientString(),
  backgroundPosition:
    passwordInput.labelbackgroundPosition ||
    passwordInput.labelbackgroundPosition ||
    "0% 0%",
  backgroundSize:
    passwordInput.labelbackgroundSize || passwordInput.labelbackgroundSize || "auto",
  backgroundRepeat:
    passwordInput.labelbackgroundRepeat ||
    passwordInput.labelbackgroundRepeat ||
    "repeat",
  backgroundAttachment:
    passwordInput.labelbackgroundAttachment ||
    passwordInput.labelbackgroundAttachment ||
    "scroll",

  fontSize: passwordInput.labelfontSize || "inherit",
  fontFamily: passwordInput.labelfontFamily || "inherit",
  fontWeight: passwordInput.labelfontWeight || "normal",
  fontStyle: passwordInput.labelfontStyle || "normal",
  fontVariant: passwordInput.labelfontVariant || "normal",
  lineHeight: passwordInput.labellineHeight || "normal",
  textAlign: passwordInput.labeltextAlign || "left",
  textDecoration: passwordInput.labeltextDecoration || "none",
  textTransform: passwordInput.labeltextTransform || "none",
  textShadow: passwordInput.labeltextShadow || "none",
  verticalAlign: passwordInput.labelverticalAlign || "baseline",
  letterSpacing: passwordInput.labelletterSpacing || "normal",
  wordSpacing: passwordInput.labelwordSpacing || "normal",
  textIndent: passwordInput.labeltextIndent || "0",
  whiteSpace: passwordInput.labelwhiteSpace || "normal",
  textOverflow: passwordInput.labeltextOverflow || "clip",
  direction: passwordInput.labeldirection || "ltr",
  unicodeBidi: passwordInput.labelunicodeBidi || "normal",
  writingMode: passwordInput.labelwritingMode || "horizontal-tb",

  opacity: passwordInput.labelopacity || "1",
  display: passwordInput.display || "inline",
  cursor: passwordInput.cursor || "auto",

  transform: passwordInput.transform || "none",
  transition: passwordInput.transition || "none",
};


  return (
    <>
      <label style={labelStyle}>{passwordInput.label || "Password"}</label>
      <input
        type={"password"}
        value={passwordInput.value}
        placeholder={passwordInput.placeholder || "Enter password"}
        style={inputStyle}
        autoComplete={passwordInput.autoComplete || "false"}
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => setIsDivHovered(false)}
        onFocus={() => setIsDivFocused(true)}
        onBlur={() => setIsDivFocused(false)}
        onMouseDown={() => setIsDivActive(true)}
        onMouseUp={() => setIsDivActive(false)}
      />
    </>
  );
};

export default PasswordInputComponent;
